import { FooterLink } from '../../components/public/PublicBranding';

// In-app footer links for the public storefront (pricing + legal) pages, so Paddle
// reviewers stay on this domain and see the on-domain, Paddle-correct versions.
export const IN_APP_FOOTER_LINKS: FooterLink[] = [
  { label: 'Pricing', href: '/pricing' },
  { label: 'Terms of Service', href: '/terms' },
  { label: 'Privacy Policy', href: '/privacy' },
  { label: 'Refund Policy', href: '/refund' },
  { label: 'Contact', href: '/contact' },
];
